module.exports = __webpack_public_path__ + "static/media/projectsActive.9cf7df88.svg";